import { render, staticRenderFns } from "./selectItem.vue?vue&type=template&id=4f4cb692&scoped=true&"
import script from "./selectItem.vue?vue&type=script&lang=js&"
export * from "./selectItem.vue?vue&type=script&lang=js&"
import style0 from "./selectItem.vue?vue&type=style&index=0&id=4f4cb692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4cb692",
  null
  
)

export default component.exports